
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import {mapGetters} from "vuex";
import Formatter from "@/utils/Formatter";
import {defineComponent, PropType} from "vue";
import TradeContractFormatView from "@/components/pages/contract/TradeContractFormat/TradeContractFormatView";
import ErrorPanel from "@/components/molecules/ErrorPanel.vue";
import AppHeader from "@/components/atoms/AppHeader.vue";
import ErrorMessage from "@/components/molecules/ErrorMessage";
import {Step} from "@/components/templates/StepperPageTemplate.vue";
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import SelectedFormatTab from "@/components/pages/contract/TradeContractFormatGroup/SelectedFormatTab.vue";
import {TradeContractFormatGroup} from "@/store/modules/hcs/tradeContractFormatGroup/model";
import {AxiosInstance} from "axios";
import FormatGroupTable from "@/components/pages/contract/TradeContractFormatGroup/FormatGroupTable.vue";
import SelectedFormatGroupTab from "@/components/pages/contract/TradeContractFormat/SelectedFormatGroupTab.vue";

export default defineComponent({
  name: "FormatGroups",
  components: {
    SelectedFormatGroupTab,
    FormatGroupTable, SelectedFormatTab, TabPageTemplate, AppHeader, ErrorPanel, BasePageTemplate},
  mixins: [Formatter],
  props: {
    tradeContracts: {
      type: Array as PropType<TradeContractFormatView[]>,
      required: true
    },
    errors: {
      type: Array as PropType<ErrorMessage[]>,
      default: () => ([])
    },
    editable: {
      type: Boolean,
      default: true
    },
    steps: {
      type: Array as PropType<Step[]>,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      groups: [] as TradeContractFormatGroup[],
      loading: false,
    };
  },
  mounted() {
    this.$watch(
      () => this.tradeContract.id,
      tradeContractId => {
        if(tradeContractId) {
          this.load();
        }
      },
      { immediate: true }
    );
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
    }),
    tradeContract(): TradeContractFormatView {
      return this.tradeContracts[0];
    },
    hcsClient(): AxiosInstance {
      const mayAxios = this.$store?.getters?.['hcs/client'];
      if(mayAxios) {
        return mayAxios;
      }
      throw new Error("store is null");
    },
    errorsView(): ErrorMessage[] {
      const errors = this.errors.slice();
      if(this.groups.length === 0) {
        errors.push({
          level: 'info',
          message: `ここで取引契約フォーマットグループに追加しておく事をお薦めします。`
        });
      }
      if(errors.length === 0) {
        errors.push({
          level: 'good',
          message: `${this.nextPageName}に進むことができます。`
        });
      }
      return errors;
    },
    nextPageName(): string {
      return this.steps[this.step + 1]?.label ?? '送信設定';
    },
  },
  methods: {
    handleGroupChanged(groups: TradeContractFormatGroup[]) {
      this.groups = groups;
      this.save();
    },
    async load() {
      const {data: groups} = await this.hcsClient.get<TradeContractFormatGroup[]>(`/trade_contract_formats/${this.tradeContract.id}/groups`)
      this.groups = groups;
    },
    async save() {
      this.loading = true;
      await this.hcsClient.post<TradeContractFormatGroup[]>(`/trade_contract_formats/${this.tradeContract.id}/groups`, {
        groupIds: this.groups.map(g => g.id),
      });
      this.loading = false;
    }
  },
});
